export default __webpack_public_path__ + "static/logo_adler-458e2c880046cbb1eecaf530122fb2dd.svg";